import React, { useState, useRef,useEffect } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from 'react-i18next';
import API from '../../api/api.jsx';
import { useLocation } from 'react-router-dom';

const FileHeader = ({ title }) => (
    <div className="file-header col d-flex justify-content-center align-items-center">
        <p className="mb-0 font-weight-bold">{title}</p>
    </div>
);

const FileDetails = ({ children }) => (
    <div className="file-details col d-flex justify-content-center align-items-center" style={{ overflow: 'hidden' }}>
        {children}
    </div>
);

const Loan002_03 = ({loan_application_id, loan_status}) => {
	const location = useLocation();	
	const params = new URLSearchParams(location.search);
  	const loanApplicationId = params.get('loanApplicationId')	

	const { t } = useTranslation();			
	const [responseData, setResponseData]     = useState([]);
	// const [file, setFile] = useState(null);	
	const [inputValue, setInputValue]         = useState('');

	const [hoveredAddBtn, setHoveredAddBtn]   = useState(false); // "담보물 추가" 버튼의 상태 변수
	const [hoveredSaveBtn, setHoveredSaveBtn] = useState(false); // "담보물 정보 저장" 버튼의 상태 변수  

	const [saveBtn, setSaveBtn]       		  = useState('추가첨부파일 저장');

	const handleMouseEnterAddBtn = () => {
		setHoveredAddBtn(true);		//첨부파일 추가버튼 hover
	};	
	const handleMouseLeaveAddBtn = () => {
		setHoveredAddBtn(false);	//첨부파일 추가버튼 hover
	};
	
	const handleMouseEnterSaveBtn = () => {
		setHoveredSaveBtn(true);	//첨부파일 저장버튼 hover
	};	
	const handleMouseLeaveSaveBtn = () => {
		setHoveredSaveBtn(false);	//첨부파일 저장버튼 hover
	};
	
	const buttonStyleAddBtn = { //첨부파일 추가버튼 css
		backgroundColor: hoveredAddBtn ? '#286A45' : '#7DA390',
		color: '#FFFFFF',
	};
	
	const buttonStyleSaveBtn = { //첨부파일 저장버튼 css
		backgroundColor: hoveredSaveBtn ? '#286A45' : '#7DA390',
		color: '#FFFFFF',
	};

	// 첨부파일 조회 함수
	const fetchLoan00204SelectData = async () => {
		try {
			const data = await API.fetchLoan00204SelectData({
				'loanApplicationId': loanApplicationId
			});

			const translatedData = data.map((item, index) => {						
				return {
					file_id   : item.file_id,
					sequence  :  index + 1,
					remark    : item.remark,
					file_name : item.file_name
				};
			});

			setResponseData(translatedData);

		} catch (error) {
			console.error('Error fetching storage data:', error);
		}
	};

	useEffect(() => {			
		if(loanApplicationId){			
			fetchLoan00204SelectData();
			setSaveBtn('추가첨부파일 수정')
		}		
	}, []);

	//내용
	const handleRemarkChange = (e, index) => {
		const { value } = e.target;
		const updatedData = responseData.map((item, i) => {
		if (index === i) {
			return { ...item, remark: value };
		}
		return item;
		});
		setResponseData(updatedData);
	};

	//첨부파일 추가 버튼 빈 row 추가
	const handleAddRow = () => { 			
		const newFile = { 
			sequence  : responseData.length + 1,  // 새로운 행의 순번 설정
			file_id   : "", // 파일 ID 초기값 설정
			file_name : "", // 파일 이름 초기값 설정
			remark    : "",  // 비고 초기값 설정
			file      : null,  // 파일 초기값 설정
			files     : null, // 여러 파일 초기값 설정
		};

		setResponseData([...responseData, newFile]);
	};

	// 파일 선택 시 호출되는 함수
	const handleFileChange = (e, index) => {
		const fileInput = e.target;
		const file = fileInput.files[0];

		setResponseData((prevData) => {
			return prevData.map((item, i) => {
				if (index === i) {
					return { 
						...item, 
						file: file, 
						file_name: file.name,
					};
				}
				return item;
			});
		});
	};

	// 파일 버튼
	const handleFileIconButton = (index) => {
		// input 엘리먼트 클릭
		const fileInput = document.getElementById(`file_${index}`);
		fileInput.click();

		// 파일이 선택된 경우, handleFileChange4 함수 호출
		fileInput.addEventListener('change', (e) => handleFileChange4(e, index));
	};

	// 파일 선택 아이콘 클릭 시 액션
	const handleFileChange4 = (e, index) => {
		const files = e.target?.files;

		if (!files || files.length === 0) {
			return; // 파일이 선택되지 않았거나 존재하지 않으면 함수 종료
		};
	
		const validExtensions = ['jpg', 'jpeg', 'png', 'pdf'];
		const invalidFiles = Array.from(files).filter(
			(file) => !validExtensions.includes(file.name.split('.').pop().toLowerCase())
		);
	
		if (invalidFiles.length > 0) {
			alert('JPG, JPEG, PNG, PDF 확장자만 허용됩니다.');
			return;
		}
	
		const fileName = Array.from(files).map((file) => file.name).join(', ');

		if (files.length > 0) {
			setResponseData((prevData) => {
				return prevData.map((item, i) => {
					if (index === i) {
						return { 
							...item, 
							files : files.length > 1 ? files : files[0], 
							file_name : fileName, 
						};
					}

					return item;
				});
			});
		}

		// 파일 정보가 업데이트되면 해당 파일을 handleFileChange 함수를 통해도 업데이트
		handleFileChange(e, index);
	};

	//추가 첨부파일 저장
	const handleSave = async (e) => {

		// 대출정보가 없는 상태에서 추가첨부파일을 수정한 경우
		if (!loanApplicationId && !loan_application_id) {
			alert('대출정보가 존재하지 않아 승인요청 할 수 없습니다.');
			return;
		};

		// 첨부파일 추가로 인해 row가 생긴 경우
		if (responseData?.some(item => !item.remark || !item.file_name)) {
			alert('파일과 remark는 필수입니다.');
			return; // 함수 종료
		}

		try {
			const response = await API.fetchLoan00204DataPOST({
				loan_application_id : loan_application_id || loanApplicationId,
				formData            : responseData
			});							

			alert('첨부파일이 저장 되었습니다.');

			setSaveBtn('추가첨부파일 수정')

			// 저장 후에 화면을 데이터 재 렌더링
			// fetchLoan00204SelectData();

		} catch (error) {
			console.error('첨부파일 정보 저장 에러:', error);
			// 에러처리에 따른 alert가 필요하다면
		}   
	};	

	// 이 함수는 인덱스를 받아 해당 인덱스의 row를 삭제합니다.
	const handleDeleteRow = (index) => {
		const updatedData = [...responseData];
		updatedData.splice(index, 1); // 해당 인덱스의 요소를 삭제합니다.
		setResponseData(updatedData); // 업데이트된 데이터를 설정합니다.
	};
	
	// 화면 UI
	return (
		<div id="collapseFour" className="accordion-collapse collapse" data-bs-parent="#accordion">
			<div className="accordion-body bg-white text-gray-900 ">
				<button type="button" className="btn text-white" style={buttonStyleAddBtn} onMouseEnter={handleMouseEnterAddBtn} onMouseLeave={handleMouseLeaveAddBtn} onClick={handleAddRow}>
						{t('LOAN_APPLICATION.첨부파일 추가', { defaultValue: '첨부파일 추가' })}+
				</button>				
				<div>
					<div className="row mb-2">
						<div className='row align-items-center'>
							<div className="col-md-1">
								<FileHeader title={t('SMS_MANAGEMENT.순번', { defaultValue: '순번' })} />						
							</div>
							<div className="col-md-6">
								<FileHeader title={t('LOAN_APPLICATION.내용', { defaultValue: '내용' })} />
							</div>
							<div className="col-md-5">
								<FileHeader title={t('LOAN_APPLICATION.파일명', { defaultValue: '파일명' })} />						
							</div>
						</div>
					</div>

					<ul className="list-group">
						{responseData.length === 0 ? (
							<li className="list-group-item text-center">{t('LOAN_APPLICATION.등록된 첨부파일이 없습니다.', { defaultValue: '등록된 첨부파일이 없습니다.' })}</li>
						) : 
							(responseData.map((item, index) => 
							<li key={index} className="list-group-item">							

								<div className='row align-items-center'>
								<input value={item.file_id}  style={{ display: 'none' }} />
									<div className="col-md-1">
										<FileDetails>{item.sequence}</FileDetails>
									</div>

									{/* 적요 */}
									<div className="col-md-6">
										<FileDetails> 										
											<input className="form-control form-control-sm" type="text" value={item.remark} onChange={(e) => handleRemarkChange(e, index)}/>
										</FileDetails>
									</div>
									
									{/* 파일명 */}								
									<div className="col-md-5">
										<FileDetails> 
											{/* <input className="form-control form-control-sm" type="file" onChange={(e) => handleFileChange(e, index)} multiple /> */}
											<input
												type="text"
												className="form-control form-control-sm"
												value={item.file_name || 'No Data.'}
												readOnly
												/>
											<button onClick={() => handleFileIconButton(index)} className="btn"><i className="fa-solid fa-upload"></i></button>
											<input
												id={`file_${index}`}
												className="form-control form-control-sm"
												type="file"
												style={{ display: 'none' }}
												onChange={(e) => handleFileChange(e, index)}
												accept=".jpg, .jpeg, .png, .pdf" // 확장자 지정												
												/>
											<button onClick={() => handleDeleteRow(index)} className="btn ml-2">X</button>
										</FileDetails>
									</div>
								</div>
						</li>))
						}
					</ul>
				</div>
				<div className = "p-1 pt-2 d-flex justify-content-center">
					{loan_status === '' || loan_status === 'S01' || loan_status ==='S04' || loan_status ==='S06'?(
						<button type="button" className="btn text-white" style={buttonStyleSaveBtn} onMouseEnter={handleMouseEnterSaveBtn} onMouseLeave={handleMouseLeaveSaveBtn} onClick={handleSave}>
							{t(`LOAN_APPLICATION.${saveBtn}`, { defaultValue: saveBtn })}
						</button>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default Loan002_03;